import React from 'react';
import { Phone, EnvelopeSimple, MapPin } from '@phosphor-icons/react';

const TopInfoStrip = () => {
  return (
    <div className="bg-[#044B3B] text-white py-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-end gap-4 sm:gap-6 text-xs sm:text-sm">
          {/* Phone - Always visible */}
          <a 
            href="tel:+18779542409" 
            className="flex items-center gap-2 hover:text-white/80 transition-colors"
            aria-label="Call us at +1 (877) 954 2409"
          >
            <Phone className="h-4 w-4 flex-shrink-0" weight="bold" />
            <span className="hidden sm:inline">+1 (877) 954 2409</span>
            <span className="sm:hidden">+1 (877) 954 2409</span>
          </a>

          {/* Email - Hidden on mobile (576px and below) */}
          <a 
            href="mailto:info@trademarkthrone.com" 
            className="hidden md:flex items-center gap-2 hover:text-white/80 transition-colors"
            aria-label="Email us at info@trademarkthrone.com"
          >
            <EnvelopeSimple className="h-4 w-4 flex-shrink-0" weight="bold" />
            <span>info@trademarkthrone.com</span>
          </a>

          {/* Address - Hidden on tablet (767px and below) */}
          <div className="hidden lg:flex items-center gap-2">
            <MapPin className="h-4 w-4 flex-shrink-0" weight="bold" />
            <span>765 Market St APT 34D, San Francisco, CA 94103</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopInfoStrip;
